//是否处于登录状态
export const onSign = state => (state.memberid.length!=0);


//授权信息
export const auth = state => ({memberid:state.memberid, authkey:state.authkey});

//是否有打印数据
export const hasPrintData = state => {
  for (let i in state.print) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/store/getters.js